import { ColumnDef } from "@tanstack/react-table";
import { useForm, useWatch } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import APIS from "../../constant/Endpoint";
import useGetHook from "../../customHooks/useGetHook";
import NACell from "../Reusable/Datatable/NACell";
import GroupedDataTable from "../Reusable/GroupedDataTable";
import Spinner from "../Reusable/Spinner";
import Filter from "./Filter";
import { useDownload } from "@careinfo/layout";
import { tw } from "@careinfo/tailwind";
import moment from "moment";
import Button from "../Reusable/Button";

const StockTrialGroup = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
    const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");
  const { download } = useDownload();
  const {
    control,
    register,
    getValues,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm<any>({
    defaultValues: {
      account: searchParams.get("account") || "",
      user: searchParams.get("user") || "",
      created: searchParams.get("created") || "",
      created__range: `${startOfMonth},${endOfMonth}`,
    },
  });
  const formValues = useWatch({ control });

  const { data, isLoading } = useGetHook({
    queryKey: [
      "stock-trail-group",
      `stock-trail-group-${JSON.stringify(formValues)}`,
    ],
    url: `${APIS.PRODUCT}grouped-items`,
    params: { ...formValues },
  });
  const handleDownloadExcel = async () => {
    try {
      const cleanedParams = Object.fromEntries(
        Object.entries(formValues)
          .filter(
            ([, value]) => value !== null && value !== undefined && value !== ""
          )
          .map(([key, value]) => [key, String(value)])
      );

      const queryString = new URLSearchParams(cleanedParams).toString();

      await download(
        `${APIS.PRODUCT}valuation-excel-download/?${queryString}`,
        `stock-valuation-${moment().format("MMMM-Do-YYYY-h-mm-ss")}.xlsx`
      );
    } catch (e) {
      console.error(e);
    }
  };
  return (
    <>
      <Filter
        register={register}
        errors={errors}
        setValue={setValue}
        getValues={getValues}
        clearErrors={clearErrors}
      />
      <div className={tw`flex justify-end mb-2`}>
        <div className={tw`w-24`}>
          <Button label="Download" onClick={() => handleDownloadExcel()} />
        </div>
      </div>
      {isLoading ? <Spinner /> : <GroupedDataTable data={data} />}
    </>
  );
};

export default StockTrialGroup;
